import React, { useState, useRef, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";
import Innerhtml from "../utils/Innerhtml";
import WsrvImage from "../utils/WsrvImage";
export default function Faq({ data }) {
  const [open, setOpen] = useState(null);
  const contentRefs = useRef([]);

  useEffect(() => {
    const handleResize = () => {
      contentRefs.current.forEach((ref, idx) => {
        if (ref && open === idx) {
          ref.style.maxHeight = ref.scrollHeight + "px";
        }
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [open]);

  return (
    <section className="pt-12 ">
      <div className="container mb-12">
        <div id="faq">
          <div className="text-center">
            {data?.heading && (
              <h2 className="text-5xl lg:text-[68px] font-bold text-black ">
                {data?.heading}
              </h2>
            )}

            {/* {data?.subHeading && (
              <h4 className="text-5xl md:text-[68px] font-bold text-black  mt-2">
                {data?.subHeading.split("||")[0] && (
                  <span>{data.subHeading.split("||")[0]}</span>
                )}

                {data.subHeading.split("||")[1] && (
                  <span className="relative inline-block lg:w-[300px]   w-[200px]">
                    <span className="text-gray-900">
                      {data.subHeading.split("||")[1]}
                    </span>
                    <img
                      src="https://i.filecdn.in/807clcworld/Vector6-1756701838368.png"
                      className="w-full h-auto  absolute  right-[10px] left-2 -top-[15px]"
                      alt=""
                    />
                  </span>
                )}
              </h3>
            )} */}

            {data?.subHeading && (
              <h3 className="text-5xl lg:text-[68px] font-bold text-black mt-2 leading-tight">
                {data.subHeading.split("||")[0] && (
                  <span>{data.subHeading.split("||")[0]}</span>
                )}

                {data.subHeading.split("||")[1] && (
                  <span className="relative inline-block ml-2 ">
                    <span className="text-gray-900 pl-2 ">
                      {data.subHeading.split("||")[1]}
                    </span>
                    <WsrvImage
                      src="https://i.filecdn.in/807clcworld/Vector6-1756701838368.png"
                      alt=""
                      width={305}
                      height={110}
                      widths={[200, 305, 400]}
                      sizes="305px"
                      className="absolute w-[310px] md:max-w-[200px] md:h-[92px] lg:max-w-[300px] lg:h-[120px] h-[80px] pb-2 left-0 right-2 top-[1px] md:top-[-10px] lg:top-[-14px]"
                    />
                  </span>
                )}
              </h3>
            )}
          </div>

          <div className="pt-16 xl:px-[140px] lg:px-[100px] px-12">
            {data?.advanceData?.data?.map((itm, idx) => (
              <div key={idx} className="border-t">
                <div
                  className={`py-4 p-2  cursor-pointer transition-colors duration-500 ease-in-out flex justify-between items-center font-medium md:py-[1.2rem] md:text-[24px] ${
                    open === idx ? "bg-white" : ""
                  } ${idx > 0 ? "border-t" : ""}`}
                  onClick={() => setOpen(open === idx ? null : idx)}
                >
                  <span>{itm.title}</span>

                  <span
                    className={`transition-transform duration-500 ease-in-out ${
                      open === idx ? "  " : "-rotate-90"
                    }`}
                  >
                    <FaChevronDown className="md:text-lg text-base" />
                  </span>
                </div>

                <div
                  ref={(el) => (contentRefs.current[idx] = el)}
                  style={{
                    maxHeight:
                      open === idx
                        ? contentRefs.current[idx]?.scrollHeight + "px"
                        : "0px",
                  }}
                  className={`transition-all duration-500 ease-in-out overflow-hidden`}
                >
                  <div className="pb-2">
                    {/* <div
                      className="p-2 md:text-[20px] text-[14px]"
                      dangerouslySetInnerHTML={{ __html: itm.desci }}
                      /> */}
                      <div    className="p-2 md:text-[20px] text-[14px]">
                      <Innerhtml data={itm.desci}/>

                      </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
